export { default } from './Person'
